import React, { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import { Grid, Menu } from "@material-ui/core";

import logo from "../../../assets/images/logo.svg";
import MenuItems from "../../../components/Navigation/MenuItems";
import { routes } from "../../../api/paths";

const useStyles = makeStyles((theme) => ({
  appBar: {
    background: "#fff",
    color: theme.palette.primary.main,
    borderBottom: `5px solid ${theme.palette.primary.main}`,
  },
  toolbar: {
    minHeight: theme.spacing(8),
  },
  logo: {
    marginRight: theme.spacing(4),
    width: 150,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  menuItem: {
    justifyContent: "center",
    textTransform: "uppercase",
    borderBottom: `1px solid ${theme.palette.grey[600]}`,
    height: theme.spacing(8),
    color: theme.palette.primary.main,
  },
  popoverPaper: {
    width: "100%",
    maxWidth: "unset",
    left: "0 !important",
    top: "69px !important",
  },
}));

type MobileNavbarProps = {
  setSelectedRequest?: React.Dispatch<React.SetStateAction<number>>;
};

export default function MobileNavbar({
  setSelectedRequest,
}: MobileNavbarProps) {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="sticky" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <Grid container justify="space-between" alignItems="center">
          <Grid item>
            <a href={routes.RODILISTA_RODA_HR}>
              <img src={logo} alt="logo" className={classes.logo} />
            </a>
          </Grid>
          <Grid item>
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="menu"
              onClick={handleClick}
            >
              <MenuIcon />
            </IconButton>
          </Grid>
        </Grid>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={!!anchorEl}
          onClose={handleClose}
          PopoverClasses={{ paper: classes.popoverPaper }}
          PaperProps={{ square: true }}
          MenuListProps={{ style: { paddingTop: 0, paddingBottom: 0 } }}
        >
          <MenuItems
            setSelectedRequest={setSelectedRequest}
            handleClose={handleClose}
            className={classes.menuItem}
          />
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
